<template>
  <div class="col-auto bg-white border-bottom q-px-md q-py-xs">
    <div class="row items-center justify-between full-width">
      <div class="col-auto">
        <div class="column">
          <div class="col-auto row items-center full-width">
            <ArrowIn
              v-if="direction === 'IN'"
              class="col-auto"
            />

            <ArrowOut
              v-if="direction === 'OUT'"
              class="col-auto"
            />

            <ArrowInOut
              v-if="direction === 'AUTO' || (!direction && !showButtonFinishChat)"
              class="col-auto"
            />

            <div
              class="col-auto q-pl-xs ellipsis"
              style="max-width: 120px"
            >
              <span class="label-name">
                {{ contact || id }}
              </span>
            </div>

            <EditName
              v-if="isText"
              :attendance="attendance"
              :contact="contact"
              :channel="channel"
            />
          </div>

          <div class="col-auto row items-center q-pb-xs">
            <WatchLogo class="col-auto watch-icon" />

            <TimerWrapper
              class="col label-info font-config blue-grey-10 q-pl-xs q-pr-sm"
              :created-at="createdAt"
              :finished-at="finishedAt"
            />

            <span
              v-if="contact && contact !== id"
              class="col-auto label-info-id q-pr-xs text-center"
            >{{ formatName(id) }}</span>
          </div>
        </div>
      </div>

      <ListBrokers
        size="13px"
        v-if="isVoice"
        class-name="col-auto q-pr-sm"
        @on-template-select="handleStartChat"
      />
      <q-icon
        color="primary"
        name="mdi-calendar"
        class="cursor-pointer"
        @click="openCalendar"
      />
      <q-btn
        dense
        no-caps
        unelevated
        padding="0"
        icon="mdi-phone-return"
        size="12px"
        class="col-auto text-green-8"
        v-if="isText && !isPreview"
        :disable="disableWhenPause"
        @click="handleStarDial"
      >
        <q-tooltip content-class="bg-green-8 text-bold">
          Discar para esse número
        </q-tooltip>
      </q-btn>

      <q-btn
        dense
        no-caps
        unelevated
        padding="0"
        icon="mdi-phone-return"
        size="12px"
        class="col-auto text-orange-8"
        @click="handleRedial"
        v-if="!showButtonFinishChat && finishedAt && isVoice && !isPreview"
      >
        <q-tooltip content-class="bg-orange-8 text-bold">
          Rediscar para o número
        </q-tooltip>
      </q-btn>

      <q-btn
        dense
        :disable="disableTransfer"
        flat
        padding="0"
        class="col-auto font-config"
        color="orange-8"
        icon="mdi-swap-horizontal"
        v-if="!isAdmin && (showButtonFinishChat || isText) && !finishedAt"
      >
        <q-menu
          class="border-menu"
          ref="menu"
          @hide="() => $emit('change-destination', null)"
        >
          <AttendanceChatTransfer
            :chat-id="attendance.id"
            :agent-id="attendance.agentId"
            :queue-id="attendance.queueId"
            :direction="attendance.direction"
            :destination="destination"
            @hide-menu="() => $refs.menu.hide()"
          />
        </q-menu>
        <q-tooltip content-class="bg-orange-8">
          <span>
            Transferir atendimento
          </span>
        </q-tooltip>
      </q-btn>

      <q-btn
        dense
        :disable="disableWhenPause"
        flat
        padding="0"
        class="col-auto font-config"
        color="red-8"
        @click="handleFinish"
        :loading="isFinishing"
        :icon="attendanceIcon"
        v-if="(showButtonFinishChat || isVoice) && !finishedAt"
      >
        <q-tooltip content-class="bg-red-8">
          <span>
            Finalizar atendimento
          </span>
        </q-tooltip>
      </q-btn>

      <AttendanceHeaderTabs
        v-if="!isPreview"
        @change-view="$emit('change-view', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TimerWrapper from '@/components/TimerWrapper'
import WatchLogo from '@/assets/icons/watch.svg'
import ArrowIn from '@/assets/icons/arrowIn.svg'
import ArrowOut from '@/assets/icons/arrowOut.svg'
import ArrowInOut from '@/assets/icons/arrowInOut.svg'
import ListBrokers from '@/components/ListBrokers'
import AttendanceHeaderTabs from './AttendanceHeaderTabs.vue'
import AttendanceChatTransfer from './AttendanceChatTransfer.vue'
import { retryStartCall, startChat } from '@/libs/startAttendance'
import EditName from './EditName'

export default {
  components: {
    ArrowIn,
    EditName,
    ArrowOut,
    WatchLogo,
    ArrowInOut,
    ListBrokers,
    TimerWrapper,
    AttendanceHeaderTabs,
    AttendanceChatTransfer
  },

  props: {
    contact: {
      type: String,
      require: true
    },

    id: {
      type: String,
      require: false
    },

    createdAt: {
      type: Number,
      require: true
    },

    finishedAt: {
      type: Number,
      require: false
    },

    channel: {
      type: String
    },

    direction: {
      type: String
    },

    showButtonFinishChat: {
      type: Boolean,
      default: false
    },

    attendance: {},

    disableWhenPause: {
      type: Boolean,
      default: false
    },

    isPreview: {
      type: Boolean,
      default: false
    },

    destination: {
      type: Number,
      default: null
    },

    disableTransfer: {
      type: Boolean,
      default: false
    }
  },

  emits: ['on-finish'],

  methods: {
    handleStarDial () {
      const vm = this
      if (!vm.attendance) return
      const attendance = { ...vm.attendance }
      attendance.contact = attendance.sourceId
      attendance.direction = ''

      retryStartCall(vm, attendance)
    },

    handleStartChat (template) {
      const vm = this
      const templateId = template.id
      const destination = vm.attendance.contact
      startChat(vm, destination, templateId, template)
    },

    handleFinish () {
      if (this.isFinishing) return
      this.$emit('on-finish')
    },

    formatName (contactId) {
      if (!contactId) return ''
      const isListenExtension = contactId.includes('*99*')
      if (!isListenExtension) return contactId
      const extension = contactId.split('*99*').pop().split('@').shift()
      return `Ouvir Ramal ${extension}`
    },

    handleRedial () {
      const vm = this
      retryStartCall(vm, vm.attendance)
    },

    openCalendar () {
      this.$router.push({
        name: 'ROUTE_CALENDAR',
        query: { attendance: JSON.stringify(this.attendance), onlyCreate: true }
      })
    }
  },

  computed: {
    ...mapGetters({
      isFinishing: 'attendanceModule/isLoading'
    }),

    isVoice () {
      return this.channel === 'VOICE'
    },

    isText () {
      return this.channel === 'TEXT'
    },

    attendanceIcon () {
      return this.isVoice ? 'mdi-phone-classic' : 'mdi-chat-remove-outline'
    }
  },

  watch: {
    deep: true,
    destination (value) {
      if (value) this.$refs.menu.show()
    }
  }
}

</script>

<style lang="sass" scoped>

.orange-finish-button
  color: #FE6600

.green-redial-button
  color: #07AE2E

.font-config
  font-weight: normal
  font-size: 13px
  line-height: 15px

.label-name
  font-weight: 500
  font-size: 13px
  line-height: 15px

.label-info
  font-style: normal
  font-weight: normal
  font-size: 12px
  line-height: 13px
  color: #263238

.label-info-id
  font-style: normal
  font-weight: bold
  font-size: 13px
  line-height: 13px
  color: #757575

.border-bottom
  border-bottom: 1px solid rgba(38, 50, 56, .1)

.watch-icon
  height: 14px
  width: 14px

.watch-icon > path
  fill: #263238

.size-button-finish
  height: 19px
</style>
